/**
 * @fileoverview AR-924 — Toast helpers of the teacher deliverable drawer and
 * the mapping from `TeacherDeliverableError` kinds to user-facing copy.
 */

import { createElement } from 'react'
import { IconCheck, IconX } from '@tabler/icons-react'
import { notifications } from 'context'
import { MAX_FILE_SIZE_MB, TeacherDeliverableError, type FileRejectionReason } from '../../teacherUpload'

type Translate = (key: string, options?: object) => string

const TOAST_ICON_SIZE = 18

export function notifySuccess(message: string): void {
  notifications.show({ message, color: 'green', icon: createElement(IconCheck, { size: TOAST_ICON_SIZE }) })
}

export function notifyError(message: string): void {
  notifications.show({ message, color: 'red', icon: createElement(IconX, { size: TOAST_ICON_SIZE }) })
}

export function fileRejectionMessage(t: Translate, name: string, reason: FileRejectionReason): string {
  return reason === 'too_large'
    ? t('task_tracker.teacher_upload.file_rejected_too_large', { name, mb: MAX_FILE_SIZE_MB })
    : t('task_tracker.teacher_upload.file_rejected_type', { name })
}

/** Backend messages (file rejections) are shown as-is; known kinds get their own copy; else `fallbackKey`. */
export function errorMessageFor(t: Translate, error: unknown, fallbackKey: string): string {
  if (error instanceof TeacherDeliverableError) {
    if (error.kind === 'student_submitted') return t('task_tracker.teacher_upload.student_already_submitted')
    if (error.kind === 'project_finished') return t('task_tracker.teacher_upload.project_finished')
    if (error.kind === 'cancelled') return t('task_tracker.teacher_upload.upload_cancelled')
    if (error.kind === 'file_rejected' && error.messages.length) return error.messages.join(' · ')
  }
  return t(`task_tracker.teacher_upload.${fallbackKey}`)
}
